import React, {Dispatch, SetStateAction} from "react";
import {FormattedMessage} from "react-intl";
import {RatingIndication} from "../model/rideInfo";

export const Indications = ({
    indications,
    selectedIndications,
    setSelectedIndications,
    commentSelected,
    handleCommentSelected,
}: {
    indications: RatingIndication[];
    selectedIndications: string[] | undefined;
    setSelectedIndications: Dispatch<SetStateAction<string[] | undefined>>;
    commentSelected: boolean;
    handleCommentSelected: () => void;
}) => {
    const togglePill = (pill: string) => {
        setSelectedIndications((prevSelectedFeedback) =>
            Array.isArray(prevSelectedFeedback) && prevSelectedFeedback.includes(pill)
                ? prevSelectedFeedback.filter((p) => p !== pill)
                : [...(prevSelectedFeedback || []), pill]
        );
    };

    return (
        <div className="pills-container">
            {indications.map((indication) => (
                <button
                    data-cy="feedback-pill"
                    key={indication.key}
                    className={`pill ${selectedIndications?.includes(indication.key) ? "selected" : ""}`}
                    onClick={() => togglePill(indication.key)}
                    aria-pressed={selectedIndications?.includes(indication.key)}
                >
                    {indication.title}
                </button>
            ))}
            {/* //FIXME: handle toggle comment */}
            {!commentSelected && (
                <button
                    data-cy="feedback-pill-comment"
                    className={`pill ${commentSelected ? "selected" : ""}`}
                    onClick={handleCommentSelected}
                >
                    + <FormattedMessage id="add_comment" />
                </button>
            )}
        </div>
    );
};
